import Typography from "@mui/material/Typography";
import CustomTimePicker from "../../../../components/formValidation/CustomTimePicker";
import ErrorHandlingForm from "../../../../components/formValidation/ErrorHandlingForm";
import {MenuItem, Stack} from "@mui/material";
import {useState} from "react";
import {
    validateMaxValue, validateMinuteDivisible,
    validateMinValue,
    validateNonNegativeNumber,
    validateNumber,
    validateRequired, validateTimeValue
} from "../../../../components/formValidation/validators";
import CustomSelect from "../../../../components/formValidation/CustomSelect";

const OccurrenceData = ({reference, obj}) => {
    const [data, setData] = useState({
        day_of_week: obj?.day_of_week || 0,
        time: obj?.time || '12:00'
    });

    const [errors, setErrors] = useState({
        day_of_week: false,
        time: false,
    });

    const validators = {
        day_of_week: [validateRequired, validateNumber, validateNonNegativeNumber, value => validateMinValue(value, 0), value => validateMaxValue(value, 6)],
        time: [validateRequired, validateTimeValue, value => validateMinuteDivisible(value, [5, 10])],
    }

    return <ErrorHandlingForm data={data} setData={setData} errors={errors} setErrors={setErrors} validators={validators} reference={reference}>
        <Stack spacing={2}>
            <Typography variant='caption'>Hét napja*</Typography>
            <CustomSelect
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='day_of_week'
                variant='standard'
            >
                <MenuItem value={0}>Hétfő</MenuItem>
                <MenuItem value={1}>Kedd</MenuItem>
                <MenuItem value={2}>Szerda</MenuItem>
                <MenuItem value={3}>Csütörtök</MenuItem>
                <MenuItem value={4}>Péntek</MenuItem>
                <MenuItem value={5}>Szombat</MenuItem>
                <MenuItem value={6}>Vasárnap</MenuItem>
            </CustomSelect>


            <Typography variant='caption'>Kezdete*</Typography>
            <CustomTimePicker
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name='time'
            />
        </Stack>
    </ErrorHandlingForm>
}

export default OccurrenceData